import React, { useState, useEffect } from 'react';

import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { Box, TextField, IconButton, InputAdornment } from '@mui/material';

import { ISearchInputProps } from 'src/components/common/types/tableTypes';

export const SearchInput: React.FC<ISearchInputProps> = ({
	initialValue = '',
	onSearch,
	onClear,
}) => {
	const [input, setInput] = useState(initialValue);
	const [isSearchApplied, setIsSearchApplied] = useState(!!initialValue);

	const handleSearch = () => {
		const trimmed = input.trim();
		if (!trimmed && !isSearchApplied) return;
		if (trimmed === initialValue) return;

		onSearch(trimmed);
		setIsSearchApplied(!!trimmed);
	};

	const handleClear = () => {
		setInput('');
		if (isSearchApplied) {
			onClear();
			setIsSearchApplied(false);
		}
	};

	useEffect(() => {
		setInput(initialValue);
		setIsSearchApplied(!!initialValue);
	}, [initialValue]);

	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				gap: { sm: 1 },
			}}
		>
			<TextField
				variant='outlined'
				size='small'
				placeholder='Search...'
				value={input}
				onChange={(e) => setInput(e.target.value)}
				onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
				InputProps={{
					endAdornment:
						input || isSearchApplied ? (
							<InputAdornment position='end'>
								<IconButton onClick={handleClear} size='small'>
									<ClearIcon fontSize='small' />
								</IconButton>
							</InputAdornment>
						) : null,
				}}
				sx={{ minWidth: 190 }}
			/>
			<IconButton onClick={handleSearch} color='primary'>
				<SearchIcon />
			</IconButton>
		</Box>
	);
};
